import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const PianoRollSideControl = ({color, track}) => { 
    let style = {
        backgroundColor: color
    };

    return (
        <div style={style} className="piano-roll-side-control">
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PianoRollSideControl);
